import React from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'
import uuidv1 from 'uuid/v1'
import { connect } from 'react-redux'
import * as firebase from 'firebase'
import FlatButton from 'material-ui/FlatButton'
import CircularProgress from 'material-ui/CircularProgress'

import withSettingsCard from '../withSettingsCard'

class APIKeys extends React.Component {
  
  static propTypes = {
    userId: PropTypes.string.isRequired,
    teamId: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props)
    this.state = { loading: true }
  }

  getSearchValue = () => {
    return `${this.props.userId}@${this.props.teamId}`
  }

  componentDidMount() {
    this.listener = firebase.database()
      .ref('api_keys')
      .orderByChild('search0')
      .equalTo(this.getSearchValue())
      .on('value', this.onUserKeyValue)
  }

  componentWillUnmount() {
    firebase.database()
      .ref('api_keys')
      .orderByChild('search0')
      .equalTo(this.getSearchValue())
      .off('value', this.onUserKeyValue)
  }

  getApiKeyValue = snapshot => {
    const value = snapshot && snapshot.val()
    if (value) {
      const values = _.map(value)
      if (values && values.length) {
        return values[0]
      }
    }
    return null
  }

  /**
   * Update keys for this user/team combination or create a new key if none
   * has been added.
   */
  saveNewAPIKey = key => {
    const dbRef = firebase.database().ref('api_keys')
    return dbRef.orderByChild('search0')
      .equalTo(this.getSearchValue())
      .once('value')
      .then(snapshot => {
        const value = this.getApiKeyValue(snapshot)
        const dbKey = value && value.id || dbRef.push().key
        return dbRef.child(dbKey).set({
          status: 'enabled',
          key,
          id: dbKey,
          userId: this.props.userId,
          teamId: this.props.teamId,
          search0: this.getSearchValue()
        })
      })
  }

  onUserKeyValue = snapshot => {
    const value = this.getApiKeyValue(snapshot)
    if (value) {
      this.setState({
        key: value.key,
        loading: false,
        loadingKeyError: false
      })
    }
    else {
      this.generateNewKey()
    }
  }

  generateNewKey = () => {
    const key = uuidv1()
    this.saveNewAPIKey(key)
      .then(() => {
        this.setState({ key, loading: false, loadingKeyError: false })
      })
      .catch(() => {
        this.setState({
          loadingKeyError: true
        })
      })
  }

  handleGenerateClicked = event => {
    event.preventDefault()
    this.generateNewKey()
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.header}>Your API key</div>
        <div style={styles.subheader}>Important: Keep your API key safe.</div>
        <div style={styles.keyContainer}>
          <div style={styles.key}>
            { this.state.loading
              ? <div style={{ width: 300 }}><CircularProgress size={22} thickness={2} color='#527da3'/></div>
              : (this.state.loadingKeyError
                ? <div style={styles.loadingError}>There was an error loading your key.</div>
                : <div style={styles.keyValue}>{ this.state.key }</div>)
            }
          </div>
          <FlatButton
            style={styles.generateButton}
            disabled={Boolean(this.state.loading)}
            labelStyle={styles.generateLabel}
            label='Generate New Key'
            onTouchTap={this.handleGenerateClicked} />
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    textAlign: 'left',
    paddingTop: 20,
    paddingBottom: 20,
    marginLeft: 24
  },
  header: {
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 8
  },
  subheader: {
    fontSize: 14,
    fontWeight: 300
  },
  keyContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 8,
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontWeight: 300,
    minWidth: 450
  },
  key: {
    marginRight: 24,
    fontSize: 16
  },
  keyValue: {
    fontFamily: 'Courier New',
    fontSize: 14
  },
  generateButton: {
    borderRadius: 3,
    backgroundColor: '#356992',
    minWidth: 64
  },
  generateLabel: {
    color: 'white',
    fontSize: 14,
    fontWeight: 400
  },
  loadingError: {
    fontSize: 14,
    color: '#f00'
  }
}

const mapStateToProps = state => ({
  teamId: state.firebase.team.metadata.value.id,
  userId: state.firebase.userAuth.id
})

export default connect(mapStateToProps)(withSettingsCard(APIKeys))



// WEBPACK FOOTER //
// ./src/settings/modules/apiKeys/APIKeys.js